var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserBoxImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.609375,
    y: 0.609375,
    width: 56.0312,
    height: 56.0312,
    rx: 11.5781,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.609375,
    y: 0.609375,
    width: 56.0312,
    height: 56.0312,
    rx: 11.5781,
    stroke: "#E3E3E3",
    strokeWidth: 1.21875
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9076 26.2751C32.9076 27.5127 32.4159 28.6997 31.5407 29.5749C30.6655 30.4501 29.4786 30.9417 28.2409 30.9417C27.0032 30.9417 25.8162 30.4501 24.9411 29.5749C24.0659 28.6997 23.5742 27.5127 23.5742 26.2751C23.5742 25.0374 24.0659 23.8504 24.9411 22.9752C25.8162 22.1001 27.0032 21.6084 28.2409 21.6084C29.4786 21.6084 30.6655 22.1001 31.5407 22.9752C32.4159 23.8504 32.9076 25.0374 32.9076 26.2751Z",
    fill: "#545454"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7649 40.2654C21.5425 40.0157 16.5742 34.8917 16.5742 28.6081C16.5742 22.1646 21.7974 16.9414 28.2409 16.9414C34.6844 16.9414 39.9076 22.1646 39.9076 28.6081C39.9076 35.0516 34.6844 40.2747 28.2409 40.2747H28.0811C27.9753 40.2747 27.8699 40.2716 27.7649 40.2654ZM20.7544 35.9697C20.6672 35.7192 20.6375 35.4523 20.6675 35.1888C20.6976 34.9252 20.7866 34.6718 20.928 34.4474C21.0694 34.223 21.2595 34.0333 21.4842 33.8924C21.7089 33.7515 21.9625 33.663 22.2261 33.6335C26.7738 33.1301 29.736 33.1756 34.2615 33.644C34.5254 33.6715 34.7796 33.7588 35.0047 33.8994C35.2298 34.04 35.4199 34.2301 35.5604 34.4552C35.7009 34.6804 35.7882 34.9346 35.8156 35.1986C35.8431 35.4625 35.8099 35.7293 35.7186 35.9785C37.6583 34.0162 38.7445 31.3672 38.7409 28.6081C38.7409 22.8092 34.0398 18.1081 28.2409 18.1081C22.442 18.1081 17.7409 22.8092 17.7409 28.6081C17.7409 31.4757 18.8906 34.0751 20.7544 35.9697Z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserBoxImg);
export default __webpack_public_path__ + "static/media/userBoxImg.6767c835be8546712c583f02629130e1.svg";
export { ForwardRef as ReactComponent };